import { connect } from 'react-redux'
import ProgressBar from './component'
import { getActiveLaunchProgress } from '../../data'
import { selectors } from '../../imports'

function mapStateToProps(state, ownProps) {
    if (ownProps.userId == null || ownProps.userId === '') {
        return {
            progress: 0,
            text: '',
            isPlaying: false,
        }
    }

    const progress = getActiveLaunchProgress(state, ownProps.userId)
    return {
        progress: progress.percent,
        text: progress.text,
        isPlaying: selectors.isPlaying(state, ownProps.userId),
    }
}

export default connect(mapStateToProps)(ProgressBar)



// WEBPACK FOOTER //
// ./src/features/LaunchProgressBar/components/ProgressBar/index.js